<template>
  <i
    v-if="list_mode"
    class="fa-regular fa-map p-2 text-center bg-white position-absolute mt-4"
    style="color:#56647A; border-radius: 12px;font-size: 1.3rem; right: 15px;"
    @click="active_map()"
  />
  <i
    v-else
    class="fa-solid fa-list-ul p-2 text-center bg-white position-absolute mt-4"
    style="color:#56647A; border-radius: 12px;font-size: 1.3rem; right: 15px;"
    @click="list_mode=true; map=null"
  />
  <div
    style="display: flex; flex-direction: column; height: 100vh;"
  >
    <div class="m-0 mt-4 px-3">
      <i
        class="fa-solid fa-angle-left px-3 py-2 text-center bg-white"
        style="color:#011638; border-radius: 12px;font-size: 1.3rem; "
        @click="handleGoBack()"
      />
      <span
        style="color:#011638; font-weight: 600; font-size: 1.1rem;"
        class="ms-2"
      >Garajes compatibles ({{ parking_lots.size }})</span>
    </div>
    <div class="row m-0 mt-3 px-3 mb-2">
      <div
        :class="list_mode && parking_lots.size > 0 ? 'col-10' : 'col-12'"
        class=" row m-0 bg-white rounded-4 py-2 px-4"
        @click="open_drawer()"
      >
        <div class="col-11 m-0 p-0">
          <p
            class="mb-0 pe-4"
            style="font-size: 0.9rem; color: #011638;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
          >
            {{ input.address.address }}<span v-if="input.address.address">,</span> {{ input.address.city }}
          </p>
          <p
            style="font-size: 0.8rem;color: #8E97A7;"
            class="mb-0"
          >
            L - V: {{ input.time.startTime }}h - {{ input.time.endTime }}h, S - D:
            <i
              v-if="input.weekend_full_day"
              class="fa-solid fa-check text-success"
            />
            <i
              v-else
              class="fa-solid fa-x text-danger"
            />
            , {{ input.vehicle_size.charAt(0).toUpperCase() + input.vehicle_size.slice(1) }}
          </p>
        </div>
        <i
          class="fa-regular fa-pen-to-square col-1 m-0 p-0 fs-4 d-flex align-items-center"
          style="color: #56647A;"
        />
      </div>
      <div
        v-if="list_mode && parking_lots.size > 0"
        class="dropdown custom-dropdown col-2 m-0 p-0 d-flex align-items-center justify-content-center"
      >
        <a
          id="dropdownMenuButton"
          style="color: #205760; text-decoration: none;"
          type="button"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i
            class="fa-solid fa-arrow-up-short-wide fs-4 "
            style="color: #56647A;"
          />
        </a>
        <ul
          class="dropdown-menu mt-2"
          aria-labelledby="dropdownMenuButton"
          style="cursor: pointer;"
        >
          <li>
            <a
              class="dropdown-item"
              @click="changeSorting('distance', 'asc')"
            >Más cercanos</a>
          </li>
          <li>
            <a
              class="dropdown-item"
              @click="changeSorting('monthly_price', 'asc')"
            >Precio menor</a>
          </li>
          <li>
            <a
              class="dropdown-item"
              @click="changeSorting('monthly_price', 'desc')"
            >Precio mayor</a>
          </li>
        </ul>
      </div>
    </div>
    <div
      v-if="list_mode && parking_lots.size > 0"
      class="px-3"
      style="overflow-y: scroll;"
    >
      <div
        v-for="([id, parking]) in Array.from(parking_lots)"
        :key="id"
        class="card mt-3 rounded-4"
      >
        <img
          src="../../src/assets/plaza.png"
          class="card-img-top rounded-top-4"
        >
        <div
          class="row card-body"
          style="font-size:1.2rem; color:#011638; font-weight: 500;"
        >
          <div class="col-8">
            <p
              style="font-size: 1.1rem;"
              class="mb-0"
            >
              {{ parking.address.street }}
            </p>
            <p
              style="color:#56647A; font-size:1rem"
              class="mb-1"
            >
              {{ parking.address.city }}, {{ parking.address.state }}
            </p>
          </div>
          <div class="col-4">
            <p class="fw-bold text-end">
              {{ parking.monthly_price }} €
              <span
                style="color:#56647A; font-size:1rem"
                class="fw-light"
              >
                /mes
              </span>
            </p>
          </div>
          <p
            style="color:#15E0DD; font-size:0.9rem"
          >
            <i class="fa-solid fa-person-walking me-2" />
            {{ getMinutesFromMeters(parking.distance) }} min
          </p>
          <div />
          <div
            class="row m-0"
            style="font-size: 0.8rem;"
          >
            <div
              class="col row align-items-start m-0 p-0"
            >
              <div
                style="background-color: #F5F6F8;"
                class="col-2 p-1 rounded-2"
              >
                <i
                  style=" color: #56647A;"
                  class="fa-regular fa-clock"
                />
              </div>
              <div
                class="col-10"
                style="color: #011638; font-size: 0.7rem;"
              >
                <p class="mb-0">
                  HORARIO
                </p>
                <p class="mb-0">
                  L - V, {{ parking.start_hour }}h-{{ parking.end_hour }}h
                </p>
              </div>
            </div>
            <div class="col row align-items-start m-0 p-0">
              <div
                style="background-color: #F5F6F8;"
                class="col-2 p-1 rounded-2"
              >
                <i
                  style=" color: #56647A;"
                  class="fa-solid fa-car"
                />
              </div>
              <div
                class="col-10"
                style="color: #011638; font-size: 0.7rem;"
              >
                <p class="mb-0">
                  TAMAÑO
                </p>
                <p class="mb-0">
                  {{ parking.vehicle_size }}
                </p>
              </div>
            </div>
            <div class="col row align-items-start m-0 p-0">
              <div
                style="background-color: #F5F6F8;"
                class="col-2 p-1 rounded-2"
              >
                <i
                  style=" color: #56647A;"
                  class="fa-regular fa-calendar"
                />
              </div>
              <div
                class="col-10"
                style="color: #011638; font-size: 0.7rem;"
              >
                <p class="mb-0">
                  PERIODO
                </p>
                <p class="mb-0">
                  {{ parking.period }}
                </p>
              </div>
            </div>
          </div>
          <div class="row gap-3 m-0 mt-3">
            <div
              style="font-size: 0.9rem !important;"
              class="col btn border border-grey rounded-4 fw-bold"
            >
              <span
                class="text-decoration-none"
                style="color: #011638;"
                @click="visit_parking(parking.id)"
              >
                Ver más detalles
              </span>
            </div>
            <div
              style="font-size: 0.9rem !important"
              class="col btn border border-grey rounded-4 fw-bold request-button"
              @click="request_parking(parking.id)"
            >
              Solicitar visita
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else-if="list_mode"
      class="px-3"
      style="flex-grow: 1;display: flex; flex-direction: column; height: 100%; "
    >
      <div
        class="d-flex align-items-center"
        style="flex-grow: 1"
      >
        <div>
          <div class="row m-0">
            <img
              class="col-5 mx-auto"
              src="../../src/assets/no_parkers_found.png"
            >
          </div>
          <h1
            style="color: #394A64;"
            class="text-center fw-semibold px-5 mt-4"
          >
            ¡ups!<br>
            Aún no hay garajes compatibles contigo, pero no te preocupes que esto puede cambiar pronto.
          </h1>
          <p
            style="color: #56647A;"
            class="text-center px-5 mt-3"
          >
            Guarda tu búsqueda para repetirla más tarde fácilmente
          </p>
        </div>
      </div>
      <button
        style=" background-color: #15E0DD;color: #011638;"
        class="btn fw-bold py-3 rounded-3 mb-4"
      >
        Guardar busqueda
      </button>
    </div>
    <div
      v-else
      style="flex-grow: 1;position: relative;"
      class="mt-3"
    >
      <div
        id="map"
        style="position:absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 0;"
      />
      <div
        v-if="selectedMarker"
        class="marker-info card rounded-4"
      >
        <div
          class="row card-body"
          style="font-size:1.2rem; color:#011638; font-weight: 500;"
        >
          <div class="col-8">
            <p
              style="font-size: 1.1rem;"
              class="mb-0"
            >
              {{ selectedMarker.address.street }}
            </p>
            <p
              style="color:#56647A; font-size:1rem"
              class="mb-1"
            >
              {{ selectedMarker.address.city }}, {{ selectedMarker.address.state }}
            </p>
          </div>
          <div class="col-4">
            <p class="text-end mb-0">
              <i
                class="fa-solid fa-xmark"
                @click="closeInfo"
              />
            </p>
            <p class="fw-bold text-end">
              {{ selectedMarker.monthly_price }} €
              <span
                style="color:#56647A; font-size:1rem"
                class="fw-light"
              >/mes</span>
            </p>
          </div>
          <p
            style="color:#15E0DD; font-size:0.9rem"
          >
            <i class="fa-solid fa-person-walking me-2" />
            {{ getMinutesFromMeters(selectedMarker.distance) }} min
          </p>
          <div />
          <div
            class="row m-0"
            style="font-size: 0.8rem;"
          >
            <div
              class="col row align-items-start m-0 p-0"
            >
              <div
                style="background-color: #F5F6F8;"
                class="col-2 p-1 rounded-2"
              >
                <i
                  style=" color: #56647A;"
                  class="fa-regular fa-clock"
                />
              </div>
              <div
                class="col-10"
                style="color: #011638; font-size: 0.7rem;"
              >
                <p class="mb-0">
                  HORARIO
                </p>
                <p class="mb-0">
                  L - V, {{ selectedMarker.start_hour }}h-{{ selectedMarker.end_hour }}h
                </p>
              </div>
            </div>
            <div class="col row align-items-start m-0 p-0">
              <div
                style="background-color: #F5F6F8;"
                class="col-2 p-1 rounded-2"
              >
                <i
                  style=" color: #56647A;"
                  class="fa-solid fa-car"
                />
              </div>
              <div
                class="col-10"
                style="color: #011638; font-size: 0.7rem;"
              >
                <p class="mb-0">
                  TAMAÑO
                </p>
                <p class="mb-0">
                  {{ selectedMarker.vehicle_size }}
                </p>
              </div>
            </div>
            <div class="col row align-items-start m-0 p-0">
              <div
                style="background-color: #F5F6F8;"
                class="col-2 p-1 rounded-2"
              >
                <i
                  style=" color: #56647A;"
                  class="fa-regular fa-calendar"
                />
              </div>
              <div
                class="col-10"
                style="color: #011638; font-size: 0.7rem;"
              >
                <p class="mb-0">
                  PERIODO
                </p>
                <p class="mb-0">
                  {{ selectedMarker.period }}
                </p>
              </div>
            </div>
          </div>
          <div class="row gap-3 m-0 mt-3">
            <div
              style="font-size: 0.9rem !important"
              class="col btn border border-grey rounded-4 fw-bold"
            >
              <router-link
                class="text-decoration-none"
                style="color: #011638;"
                :to="`/alquiler-garaje/${selectedMarker.id}`"
              >
                Ver más detalles
              </router-link>
            </div>
            <div
              style="font-size: 0.9rem !important"
              class="col btn border border-grey rounded-4 fw-bold"
              :class="isLoggedIn ? 'request-button' : 'disable-button'"
            >
              Solicitar visita
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <drawer
    ref="drawer"
    :input="input"
    @get-data-input="handleGetInput"
  />
  <drawer-login
    ref="drawer_login"
  />
  <spinner-component
    id="spinner"
    class="d-none"
  />
</template>
<script>
  import L from 'leaflet';
  import 'leaflet.markercluster';
  import axios from 'axios';
  import { mapState } from 'vuex';
  //import router from '@/router';
  import Drawer from '../components/Drawer.vue';
  import DrawerLogin from '../components/DrawerLogin.vue';
  import { nextTick } from "vue";
  import SpinnerComponent from '../components/SpinnerComponent.vue';

  export default {
    name: 'FindParkers',
    components:{
      Drawer,
      DrawerLogin,
      SpinnerComponent
    },
    data: function() {
      return {
        list_mode:true,
        map: null,
        selectedMarker: null,
        input: {
          address: {
            address:null,
            centro: null,
            city: null
          },
          time: {
            startTime: "08:00",
            endTime: "18:00"
          },
          weekend_full_day: false,
          vehicle_size: "",
          field: "distance",
          direction: "asc",
          bbox: ""
        },
        addresses: [],
        parking_lots: new Map(),
        markersLayer: []
      }
    },
    computed: {
      ...mapState(['isLoggedIn']),
    },
    watch:{
        step(){
            switch(this.step){
              case 1:
                  this.isCollapsed=false;
                  break;
              case 2:
                  this.isCollapsed=true;
                  break;
              case 3:
                  this.isCollapsed=true;
                  break;
            }
        }
    },
    mounted(){
        const objeto = this.$route.query;
        console.log(objeto);
        this.input = objeto;

        const address = this.$route.query.address
          ? JSON.parse(this.$route.query.address)
          : null;
        this.input.address = address

        const time = this.$route.query.time
          ? JSON.parse(this.$route.query.time)
          : null;
        this.input.time = time
        
        this.fetchParkings();
        
    },
    methods: {
      request_parking(id){
        if(!this.isLoggedIn){
          this.$refs.drawer_login.openDrawer()
        }else{
          this.$store.dispatch('setInput', this.input);
          this.$router.push("/alquiler-garaje/"+id);
        }
      },
      visit_parking(id){
        this.$store.dispatch('setInput', this.input);
        this.$router.push("/alquiler-garaje/"+id);
      },
      handleGoBack(){
        if (this.list_mode) {
          this.$router.go(-1);
          return
        }
        this.list_mode = true
      },
      handleGetInput(input){
        this.input = input
        this.parking_lots = new Map()

        if(this.list_mode){
          this.fetchParkings()
        }else{
          this.map.setView([this.input.address.center[0], this.input.address.center[1]], 18);
          this.updateParkings()
        }
      },
      active_map(){
        this.list_mode=false

        nextTick(() => {
          const mapContainer = document.getElementById("map");
          if (!mapContainer) {
              return;
          }
          if (!this.map){
            this.map = L.map("map", {
              zoomControl: true,
              zoom: 1,
              zoomAnimation: true,
              fadeAnimation: true,
              markerZoomAnimation: true,
              scrollWheelZoom: true,
              dragging: true,
            });
            this.map.invalidateSize();
            this.map.setView([this.input.address.center[0], this.input.address.center[1]], 18);

            const customIcon = L.icon({
              iconUrl: require("@/assets/driver_icon.png"), // Ruta a la imagen
              iconSize: [50, 50], // Tamaño del ícono
              iconAnchor: [20, 30], // Punto de anclaje (base del ícono)
              popupAnchor: [0, -40], // Punto del popup relativo al ícono
            });
            L.marker([this.input.address.center[0], this.input.address.center[1]], { icon: customIcon }).addTo(this.map);


            L.tileLayer("https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png", {
                maxZoom: 20,
                minZoom: 1,
            }).addTo(this.map);

            this.markersLayer = L.layerGroup().addTo(this.map);
          }
          this.map.whenReady(() => {
            // TODO: llamada endpoint por coords
            console.log("Mapa listo, agregando markers...");
            this.map.setView([this.input.address.center[0], this.input.address.center[1]], 18);

            this.updateParkings()
            this.map.on("moveend", this.updateParkings);
          });
        });
      },
      updateParkings(){
        const bounds = this.map.getBounds();

        const northEast = bounds.getNorthEast(); // Esquina superior derecha
        const southWest = bounds.getSouthWest(); // Esquina inferior izquierda
        this.bbox = `${southWest.lng},${southWest.lat},${northEast.lng},${northEast.lat}`;

        this.fetchParkings();

        this.clearMarkers();

        const customIcon = L.icon({
          iconUrl: require("@/assets/driver_icon.png"), // Ruta a la imagen
          iconSize: [50, 50], // Tamaño del ícono
          iconAnchor: [20, 30], // Punto de anclaje (base del ícono)
          popupAnchor: [0, -40], // Punto del popup relativo al ícono
        });
        L.marker([this.input.address.center[0], this.input.address.center[1]], { icon: customIcon }).addTo(this.map);

        this.addMarkers();
      },
      addMarkers() {
        this.parking_lots.forEach(parking => {
          const customIcon = L.icon({
              iconUrl: require("@/assets/parker_icon.png"), // Ruta a la imagen
              iconSize: [40, 50], // Tamaño del ícono
              iconAnchor: [20, 30], // Punto de anclaje (base del ícono)
              popupAnchor: [0, -40], // Punto del popup relativo al ícono
            });
          const marker = L.marker([parking.location.latitude, parking.location.longitude], { icon: customIcon });
          marker.on("click", () => this.showMarkerInfo(parking));
          this.markersLayer.addLayer(marker);
        });
      },
      showMarkerInfo(parking) {
        this.selectedMarker = parking;
        this.map.setView([parking.location.latitude, parking.location.longitude]);
      },
      closeInfo() {
        this.selectedMarker = null;
      },
      clearMarkers() {
        if (this.markersLayer) {
          this.markersLayer.clearLayers();
        }
      },
      open_drawer(){
        this.$refs.drawer.openDrawer()
      },
      getMinutesFromMeters(meters){
        return Math.round(meters * 11 / 1000)
      },
      changeSorting(field, direction){
        this.input.field = field
        this.input.direction = direction
        this.fetchParkings();
      },
      fetchParkings() {
        if (this.input.address && this.input.time) {
          var spinner = document.getElementById("spinner");
            spinner.classList.remove("d-none");
            const payload = {
                location: {
                    latitude: this.input.address.center[0],
                    longitude: this.input.address.center[1],
                },
                weekend_full_day: this.input.full_sd === 'true',
                time_range: {
                    start: parseInt(this.input.time.startTime.split(':')[0], 10),
                    end: parseInt(this.input.time.endTime.split(':')[0], 10),
                },
                vehicle_size: this.input.vehicle_size,
                field: this.input.field,
                direction: this.input.direction,
                bbox: this.bbox
            };

            console.log("Payload para enviar:", payload);
            
            const url = process.env.VUE_APP_API_URL+'/api/onboarding/find-parkers';

            axios.post(url, payload)
            .then((response) => {
                console.log('Respuesta del servidor:', response.data);

                response.data.forEach(p => {
                    if (!this.parking_lots.has(p.id)) {
                        this.parking_lots.set(p.id, p);
                    }
                });

                spinner.classList.add("d-none");
            })
            .catch((error) => {
                console.error('Error al hacer la llamada:', error);
                spinner.classList.add("d-none");
            });
        } else {
            console.error('Datos insuficientes para hacer la llamada.');
        }
}
    }
  }
</script>
<style scoped>
  .marker-info {
    position: absolute;
    bottom: 20px;
    left: 20px;
    width: calc(100vw - 40px);
  }

  .request-button{
    color: #011638;
    background-color: #15E0DD;
  }

  .disable-button{
    color: #8E97A7;
    background-color: #E3E5E9;
  }
</style>
